module.exports = __webpack_public_path__ + "img/Classic@2x.6bea608a.png";